// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"129":"registration","430":"static","507":"session","580":"schedule","990":"papers"}[chunkId] || chunkId) + "-legacy." + {"129":"d924490a","430":"26e5d2ff","507":"144cce7a","554":"b0eed821","580":"f5db6756","990":"f340e1e7"}[chunkId] + ".js";
};